import { render, staticRenderFns } from "./MissionPreek.vue?vue&type=template&id=85a2d3aa&scoped=true"
import script from "./MissionPreek.vue?vue&type=script&lang=js"
export * from "./MissionPreek.vue?vue&type=script&lang=js"
import style0 from "./MissionPreek.vue?vue&type=style&index=0&id=85a2d3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a2d3aa",
  null
  
)

export default component.exports